import styled from 'styled-components';
import { colors } from '../../../../theme/style-helpers';

export const Container = styled.div`
    position: relative;
    display: grid;
    grid-auto-flow: row;
    row-gap: 8px;
    grid-auto-rows: max-content;
`;

export const Content = styled.textarea`
    padding: 16px 16px;
    word-break: keep-all;
    border: 1px solid #63666A;
    border-radius: 1px;
    min-height: ${({ noMinHeight }) => (noMinHeight ? '0' : '124px')};
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    color: ${colors.BLACK};
    padding-right: ${({ isClearable }) => (isClearable ? '48px' : '16px')};
    overflow: hidden;
    resize: none;
    display: block;

    &:focus {
        outline-color: #FFDFD0;
        outline-width: 3px;
        outline-offset: 2px;
        border-color: #D9D9D6;
    }

    &:hover:not(:focus) {
        border-color: ${colors.BLACK};
    }

    &::placeholder {
        color: #AAAAAA;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const Counter = styled.p`
    position: absolute;
    bottom: 0;
    right: 16px;
    margin: 0;
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    color: #757575;
`;

export const ClearButton = styled.button`
    position: absolute;
    top: 16px;
    right: 16px;
    background: none;
    border: none;
    padding: 6px 0;
    cursor: pointer;
    outline: none;
`;

export const AdditionalInfo = styled.p`
    margin: 0;
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    color: #757575;
`;

export const ErrorMessage = styled.p`
    margin: 0;
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    color: #D44333;
`;
